import * as z from "zod";

// Common field schemas
const titleSchema = z
  .string()
  .min(1, "Title is required")
  .max(100, "Title must be less than 100 characters");

const descriptionSchema = z.string().optional();

const typeIdSchema = z.string().min(1, "Type is required");

const locationSchema = z.string().min(1, "Location is required");

const statusSchema = z.enum(["Open", "Pending", "Closed"]).default("Pending");

// Common type object schema
const typeObjectSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  llm_context: z.string().default(""),
  assigned_users: z.array(z.any()),
  in_use: z.boolean()
});

// Base request schema (common fields)
const baseRequestSchema = z.object({
  title: titleSchema,
  description: descriptionSchema,
  type: typeObjectSchema
});

// Schema for creating a new workplace request
export const createWorkplaceRequestSchema = z.object({
  title: titleSchema,
  description: descriptionSchema,
  type: typeIdSchema,
  location: locationSchema,
  submitter: z.string().optional(),
  status: statusSchema,
  owner: z.string().optional()
});

// Schema for managing multiple workplace requests in reservation context
export const workplaceRequestsFormSchema = z.object({
  requests: z.array(
    baseRequestSchema.extend({
      id: z.string(),
      isNew: z.boolean().optional(),
      isDeleted: z.boolean().optional(),
      originalData: z.any().optional()
    })
  )
});

// Type exports for TypeScript
export type CreateWorkplaceRequestFormValues = z.infer<
  typeof createWorkplaceRequestSchema
>;
export type WorkplaceRequestsFormValues = z.infer<
  typeof workplaceRequestsFormSchema
>;
